import { schemas } from 'constants/schemas';
import { SMSNotification } from 'models/smsNotification';
import { normalizeResponse } from 'utils/normalize/normalize';

import { SMSNotificationResponse } from 'services/payex/payments/types';

export const normalizeSmsNotifications = (
  smsNotification: SMSNotificationResponse,
): {
  entities: {
    smsNotification: Record<string, SMSNotification>;
  };
  result: string[];
} => normalizeResponse(smsNotification, schemas.smsNotification);
